jQuery(document).ready(function ($) {

  
  // Hide "Frame" option from dropdown select
  setTimeout(function(){
    var frame_option = $('.select').find('option:contains("Frame")');
    var frame_option1 = $('.select').find('option:contains("frame")');
    frame_option.hide();
    frame_option.remove();
    frame_option1.hide();
    frame_option1.remove();
  }, 3000);

  setTimeout(function(){
    var art_option = $('.select').find('option:contains("Art")');
    art_option.hide();
    art_option.remove();
  }, 3000);


  // show background overlay on mega menu click
  $('.mega-menu-parent').on('mouseenter', function(){
    $('#background_overlay').fadeIn();
  })
  $('.main_nav_wrapper').on('mouseleave', function(){
    $('#background_overlay').fadeOut();
  })

  // custom product title input box on saved-designs products
  
  
  $('.custom-select').each(function () {
    var $this = $(this),
    numberOfOptions = $(this).children('option').length;

    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    // $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
      'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
        text: $this.children('option').eq(i).text(),
        rel: $this.children('option').eq(i).val()
      }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function (e) {
      e.stopPropagation();
      $('div.select-styled.active').not(this).each(function () {
        $(this).removeClass('active').next('ul.select-options').hide();
      });
      $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $list.hide();
    //console.log($this.val());
    });

    $(document).click(function () {
      $styledSelect.removeClass('active');
      $list.hide();
    });

  });

  // New account management
  $('.account-sidebar a[href="#"]').on('click', function (e) { 
    e.preventDefault();
    var tab_href = $(this).data('href');
    $('.tab-content').removeClass('opened');
    $('.tab-content[data-tab="' + tab_href + '"]').addClass('opened');
    $('.account-sidebar a').removeClass('active');
    $(this).addClass('active');
    $('.account-header .current_tab').text($(this).text());

    // Hide reseller sticky bar on reseller tab selected
    $('.reseller_sticky-wrapper').show();
    if($(this).hasClass('tab-my_reseller')){
      $('.reseller_sticky-wrapper').hide();
    }
  })

  $('.view_orders_btn').on('click', function(e){
    e.preventDefault();
    $('.tab-content').removeClass('opened');
    $('.tab-content[data-tab="my_orders"]').addClass('opened');
    $('.account-sidebar a').removeClass('active');
    $('.tab-my_orders').addClass('active');
    $('.account-header .current_tab').text($(this).text());
  })

// Mobile account sidebar action
  $(document).ready(function () {
    $('#mobile-account_dropdown').on('change', function () {
        var selectedOption = $(this).find('option:selected');
        var selectedValue = selectedOption.val();
        var link = selectedOption.data('link'); 

        if (link) {
            window.open(link, '_blank'); 
            return;
        }

        $(this).siblings('.select-styled').text(selectedValue);

        $('.tab-content').removeClass('opened');

        switch (selectedValue) {
            case 'art for Dealer Showrooms':
                $('.tab-content[data-tab="art_showroom"]').addClass('opened');
                break;
            case 'My Reseller Account':
                $('.tab-content[data-tab="my_reseller_account"]').addClass('opened');
                break;
            case 'Personal Data':
                $('.tab-content[data-tab="personal_data"]').addClass('opened');
                break;
            case 'My Orders':
                $('.tab-content[data-tab="my_orders"]').addClass('opened');
                break;
            case 'Showroom Demos':
                $('.tab-content[data-tab="showroom"]').addClass('opened');
                break;
            default:
                $('.tab-content').first().addClass('opened');
        }
    });

    var initialValue = $('#mobile-account_dropdown').val();
    $('#mobile-account_dropdown').siblings('.select-styled').text(initialValue);

    $('.mobile-account_sidebar .select-styled').on('click touchend', function (e) {
        e.stopPropagation();
        $(this).siblings('.select-options').toggle();
    });

    $(document).on('click touchend', function () {
        $('.mobile-account_sidebar .select-options').hide();
    });
});


  // Add new address
  $('.new_address').on('click', function () {
    $('.add_address').toggle();
  })

  // Edit address
    $('.account-addresses .edit_button').on('click', function () {
      var edit_formId = '#edit_address_' + $(this).data('id');
      $(edit_formId).show();
    })

  // Change account email and password
    $('.sidebar-button[data-target]').on('click', function () {
      $('.tab-content.opened').find('.sidebar-card').hide();
      $('.tab-content.opened').find('.sidebar-card_title').hide();
      var target_class = '.' + $(this).data('target');
      $(target_class).show();
    })
  // Cancel button
    $('.sidebar-card .action_cancel').on('click', function () {
      $('.tab-content.opened').find('.sidebar-card_title').show();
      $(this).parents('.sidebar-card').hide();
      $(this).parents('.tab-content').find('.sidebar-card:not(".hidden")').show();
    })

  // Customer Registration form validation
  var registration_submit_btn = $('#create_customer .action_button');
  registration_submit_btn.on('click', function(e){
    e.preventDefault();

    var registration_email = $('#create_customer #email').val();
    if( registration_email.indexOf('xyz') > -1 ){
      alert('Email contains an invalid domain name. Please check your email again!');
      return false;
    }
    else{
      $('#create_customer').submit();
    }
  })

  // Redeem a Credit button
  $('.btn-redeem_credit').on('click', function(e){
    e.preventDefault();

    $('.redeem-credit-remodal').remodal().open();
  })

  // $.ajax({
  //   url: 'https://freegeoip.app/json/',
  //   dataType: 'json'
  // }).done(function(response){
  //   if( response.country_code == 'MX' ){
  //     $.fancybox.open({
  //       src  : '#mexico_popup',
  //       type : 'inline',
  //       buttons: ["close"],
  //       opts : {
  //         afterShow : function( instance, current ) {
  //           console.info( 'Mexico Banned!' );
  //           $('.add_to_cart').hide();
  //           $('.shopify-payment-button').hide();
  //         }
  //       }
  //     });
  //   }
  // })

  //   // Count down timer
  //   function makeTimer() {
  //     //		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
  //     var endTime = new Date("7 September 2020 23:59:00 GMT-05:00");			
  //       endTime = (Date.parse(endTime) / 1000);
  
  //     var now = new Date();
  //     now = (Date.parse(now) / 1000);

  //     var timeLeft = endTime - now;

  //     var days = Math.floor(timeLeft / 86400); 
  //     var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
  //     var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
  //     var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
  //     if (hours < "10") { hours = "0" + hours; }
  //     if (minutes < "10") { minutes = "0" + minutes; }
  //     if (seconds < "10") { seconds = "0" + seconds; }

  //     $(".days").html(days + "<span>Days</span>");
  //     $(".hours").html(hours + "<span>Hours</span>");
  //     $(".minutes").html(minutes + "<span>Minutes</span>");
  //     $(".seconds").html(seconds + "<span>Seconds</span>");		
  // }
  
  // setInterval(function() { makeTimer(); }, 1000);

  $('.save_design-atc').on('click', function(e){
    e.preventDefault();
    $('.saved-design-remodal').remodal().open();
  })
  $('.saved_design-submit').on('click', function(e){
    $('#saved_design_fullname').val($('.saved_design-fullname').val());
    $('.shopify-product-form').submit();
  })

  // Show popup on Antique white frame PDP
  if($('.product-name--antique-white-samsung-frame').length){
    setTimeout(function(){
      $.fancybox.open($('#antiquie_popup'));
    }, 20000);
  }

  // Pick up size notification

  $('.pickup_size_form').on('click','.add_to_cart',function(e){
    e.preventDefault();
    
    var sizewrap = $('.swatch.clearfix.model_year').length;
    var sizeelements = $('.swatch.clearfix.model_year input:radio').length;
    var checkedelements = $('.swatch.clearfix.model_year input:radio:checked').length;
    
    if(sizewrap && (sizeelements > 1)){
      var size_class = $('.swatch.clearfix.model_year.sizenotselected').length;
      var $pick_msg = $('.pickup_err_msg');	  
      if(size_class){
        $pick_msg.slideDown();
        return false;
      } else {
        $('.pickup_size_form form').submit();  
        $pick_msg.slideUp();
      }
    } else if(sizewrap && (sizeelements == 1)){
        $('.swatch.clearfix.model_year input:radio').prop("checked", true);
        $('.pickup_size_form form').submit();  
        $('.pickup_err_msg').slideUp();
    } else {
        $('.pickup_size_form form').submit();
    }
  });

  $('.swatch.clearfix.model_year').click(function(){
    $('.swatch.clearfix.model_year').removeClass('sizenotselected');
    $('.pickup_err_msg').slideUp();
  });
  $('.swatch.clearfix.model_year').addClass('sizenotselected');

  // Show cart popup alert if cart has Frame
  if($('.cart_popup-alert').length){
    $.fancybox.open($('.cart_popup-alert'));
  }

  $.ajax({
    url: '/browsing_context_suggestions.json',
    dataType: 'json'
  }).done(function(response){
    if( response.detected_values.country.handle != 'US' ){
      console.log(response)
      $('.promo-banner').hide();
    }
  })

  $('.BF_toggle').on('click', function(e){
    e.preventDefault();
    Cookies.set('bfcm_popup', false);
    if($(this).hasClass('active')){
      $( ".BF_Footer" ).animate({
        bottom: '-280px'
      },300, "linear")
      $(this).removeClass('active');
    }
    else{
      $( ".BF_Footer" ).animate({
        bottom: '0'
      },300, "linear")
      $(this).addClass('active');
    }
  })

  if(Cookies.get('bfcm_popup') == 'false'){
    $('.BF_Footer').addClass('closed');
    $('.BF_toggle').removeClass('active');
  }

  // About us - Timeline carousel
  $('.timeline-item span').on('click', function(e){
    e.preventDefault();
    let target = $(this).data('target');
    $('.timeline-item').removeClass('active');
    $(this).parent().addClass('active');
    $('.timelines-wrapper .image-with-text-container').hide();
    $(target).fadeIn();
  })

  // Hide freeshipping banner for customers from US territories
  $.ajax({
    url: 'https://ipinfo.io/json',
    dataType: 'json'
  }).done(function(response){
    if( response.region == 'American Samoa' || response.region == 'Guam' || response.region == 'Marshall Islands' || response.region == 'Northern Mariana Islands' || response.region == 'Palau' || response.region == 'Puerto Rico' || response.region == 'U.S. Virgin Islands' || response.region == 'Hawaii' || response.region == 'Alaska' )
      $('.promo-banner').hide();
  })

  // Custom discounted box / show discounted price
  if($('.custom_discount_info_plp').length > 0){
    var discount_code_cookie = Cookies.get("discount_code");
    $('.custom_discount_info_plp').each(function(index){
      let discount_code = $(this).data('code');
      if(discount_code_cookie == discount_code){
        $(this).next().addClass('active');
      }
    })
  }
})

/* Popup when 2 same size frame added */
function initCheckoutInterception() {
  const buttons = document.querySelectorAll('[name="checkout"]');
  if (!buttons.length) return;

  buttons.forEach(btn => {
    if (btn.dataset.listenerAdded) return; // Prevent double-binding
    btn.dataset.listenerAdded = "true";

    btn.addEventListener("click", (e) => {
      if (btn.dataset.bypassPopup === "true") return; // Let it pass on second click

      e.preventDefault();
      e.stopImmediatePropagation();

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          return Promise.all(
            cart.items.map(item =>
              fetch(`/products/${item.handle}.js`)
                .then(res => res.json())
                .then(prod => ({
                  item,
                  handle: item.handle,
                  tags: prod.tags
                }))
            )
          );
        })
        .then(items => {
          const relevant = items.filter(p => p.tags.includes("deco tv frame"));

          const sizeMap = {};
          relevant.forEach(({ item, handle }) => {
            const size = item.options_with_values.find(opt =>
              ["to fit diagonal tv size", "size"].includes(opt.name.toLowerCase())
            )?.value;
          
            const modelYear = item.options_with_values.find(opt =>
              opt.name === "Samsung Frame TV Model Year"
            )?.value;
          
            const key = `${size}___${modelYear}`;
            if (!sizeMap[key]) sizeMap[key] = new Set();
            sizeMap[key].add(handle);
          });


          const conflict = Object.values(sizeMap).some(set => set.size > 1);
          if (conflict) {
            showFramePopup(() => {
              btn.dataset.bypassPopup = "true"; // Allow next click
              btn.click(); // Trigger real Navidium checkout logic
            });
            return;
          }

          // No conflict, allow regular checkout
          btn.dataset.bypassPopup = "true";
          btn.click();
        });
    });
  });
}

function showFramePopup(onContinue) {
  if (document.getElementById("frame-warning-popup")) return;

  const popup = document.createElement("div");
  popup.id = "frame-warning-popup";
  popup.className = "buy2-popup-overlay";
  popup.innerHTML = `
    <div class="buy2-popup">
      <h3>Undecided? Totally Normal.</h3>
      <p>
        If you’re torn between styles, ordering both just to return one adds waste and delay. Skip the hassle—our customer service team can send <strong>up to three free samples</strong> to help you choose the perfect showstopper! Just chat, call, or email us.
      </p>
      <p>Chasing a promo? Ask us to flag your account so you don’t miss the deal.</p>
      <p>Framing two TVs? Awesome—carry on, and thank you for supporting Made in America!</p>
      <div class="buy2-popup-actions">
        <button id="continueCheckoutBtn" class="buy2-popup-btn">Continue to Checkout</button>
        <button class="buy2-popup-cancel">Cancel</button>
      </div>
    </div>`;

  document.body.appendChild(popup);

  document.getElementById("continueCheckoutBtn")
    .addEventListener("click", () => {
      popup.remove();
      onContinue();
    });

  document.querySelector(".buy2-popup-cancel")
    .addEventListener("click", () => {
      popup.remove();
    });
}



// Start observing when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initCheckoutInterception();

  const observer = new MutationObserver(() => {
    initCheckoutInterception();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* Popup when 2 same size frame added */


/* Discount badge PDP after checkout back to website */

window.applyDiscountBadge = function(product, variant, code, percent, activeFixed, fixed, min) {
  console.log("product changing1");
  let $product = $(product); 

  if ($product.find('.custom_discount_info').length > 0) {
    let discount_percent = parseInt(percent) / 100;

    if (activeFixed == "true" || activeFixed === true) {
      let discount_price = parseInt(fixed) * 100;
      let min_price = parseInt(min) * 100;

      if (variant.price >= min_price) {
        //if reseller, apply percent on dealer_price instead of fixed amount
        let finalPrice;
        if ($product.find('.dealer_price').length) {
          let dealer_price = variant.price * $product.find('.dealer_price').data('discount-percent') / 100;
          finalPrice = dealer_price * (1 - discount_percent);
        } else {
          finalPrice = variant.price - discount_price;
        }

        $product.find('.discounted_amount').html(
          Shopify.formatMoney(finalPrice, $('body').data('money-format'))
        ).removeClass('hidden');
        $product.find('.modal_price .price', $product).addClass('was_price');
      } else {
        $product.find('.discounted_amount').html('').addClass('hidden');
        $product.find('.modal_price .price', $product).removeClass('was_price');
      }
    } else {
      if ($product.find('.dealer_price').length) {
        $product.find('.dealer_price .current_price').addClass('was_price');

        let dealer_price = variant.price * $product.find('.dealer_price').data('discount-percent') / 100;

        $product.find('.discounted_amount').html(
          Shopify.formatMoney(dealer_price * (1 - discount_percent), $('body').data('money-format'))
        ).removeClass('hidden');
      } else {
        $product.find('.discounted_amount').html(
          Shopify.formatMoney(variant.price * (1 - discount_percent), $('body').data('money-format'))
        ).removeClass('hidden');
      }

      
    }
    $product.find('.modal_price .price', $product).addClass('was_price');
    $product.find('.discount_code_box').addClass('active');
  }
}
/* Discount badge PDP after checkout back to website */

/* Reactivation Popup */
document.addEventListener("DOMContentLoaded", function () {


  const input = document.getElementById("popup-input-reactivation");
  const button = document.getElementById("apply-btn-reactivation");
  const popup = document.getElementById("custom-popup-reactivation");

  const step1 = document.getElementById("popup-step-1-reactivation");
  const step2 = document.getElementById("popup-step-2-reactivation");

  if (!popup) return;

  function openPopup() {
    popup.style.display = "flex";
  }

  function closePopup() {
    popup.style.display = "none";
  }

  window.closePopup = closePopup;

  // Enable / disable button
  if (input && button) {
    input.addEventListener("input", function () {
      const hasValue = input.value.trim().length > 0;
      button.disabled = !hasValue;
      button.classList.toggle("disabled", !hasValue);
    });
  }

  // APPLY REACTIVATION CODE
  window.applyAction = function () {
    const code = input.value.trim();
    if (!code) return;

    button.innerText = "Applying...";
    button.disabled = true;

    window.location.href = `/discount/${code}?redirect=/account&reactivated=true`;
  };

  // CHECK URL PARAM
  const params = new URLSearchParams(window.location.search);
  const isReactivated = params.get("reactivated") === "true";

  const successShown = localStorage.getItem("reactivation_success_shown");

  // SUCCESS FLOW
  if (isReactivated && !successShown) {
    openPopup();

    if (step1) step1.style.display = "none";
    if (step2) step2.style.display = "block";

    localStorage.setItem("reactivation_success_shown", "true");

    window.history.replaceState({}, document.title, window.location.pathname);

    return;
  }

  // NORMAL FLOW
  if (!successShown) {
    openPopup();
  }



});


  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".js-go-to-collections");
    if (!btn) return;

    window.location.href = "/collections/all-deco-frames";
  });
  
 /* Reactivation Popup */ 

/* Sale badge on product scroll */
document.addEventListener("DOMContentLoaded", function () {
  const productContainer = document.querySelector('.product-list');

  function applyCustomMods() {
    const activeBoxes = document.querySelectorAll('.discount_code_box_plp.active');

    if (activeBoxes.length > 0) {
      $('.discount_code_box_plp').addClass('active');
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('.one-third')) {
          applyCustomMods();
        }
      });
    });
  });

  observer.observe(productContainer, { childList: true, subtree: true });
});

/* Sale badge on product scroll */

/* 98" size confirmation popup */

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('size-98-popup');
  const closeBtn = popup?.querySelector('.close-btn');
  const confirmBtn = document.getElementById('confirm-size-98');
  const initialsInput = document.getElementById('size-98-initials');

  document.querySelectorAll('form.shopify-product-form').forEach(function (form) {
    const button = form.querySelector('.add_to_cart[name="add"]');
    if (!popup || !button || !confirmBtn || !initialsInput) return;

    function isSize98Selected() {
      const checked = form.querySelector('input[name="option-0"]:checked');
      return checked?.value === '98"';
    }

    button.addEventListener('click', function (e) {
      if (!isSize98Selected()) return; // not the 98" variant, let normal add-to-cart proceed
      e.preventDefault();
      e.stopImmediatePropagation();
      popup.style.display = 'flex';
    });
  });

  closeBtn?.addEventListener('click', () => popup.style.display = 'none');

  initialsInput.addEventListener('input', () => {
    confirmBtn.disabled = initialsInput.value.trim().length === 0;
  });

  confirmBtn.addEventListener('click', function () {
    const initials = initialsInput.value.trim();
    if (!initials) return;
    const activeForm = document.querySelector('.add_to_cart[name="add"]')?.closest('form');
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = 'properties[Restocking fee policy accepted by]';
    hiddenField.value = initials;
    activeForm.appendChild(hiddenField);
    popup.style.display = 'none';
    activeForm.submit();
  });

  popup.addEventListener('click', function (e) {
    if (e.target === popup) popup.style.display = 'none';
  });
});

/* 98" size confirmation popup */ 